import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const klaviyoTemplate = {
	id: 'klaviyo',
	guid: '6ef4d0c6-9e32-4b33-91b4-4e6f2299d816',
	name: 'Klaviyo',
	category: TEMPLATE_CATEGORIES.MARKETING,
	popularity: 'Popular',
	color: '#000000',
	icon: 'mdi-email-variant',
	description: 'Connect to Klaviyo for email marketing and SMS automation.',
	features: ['API Key Auth', 'Email Campaigns', 'SMS Marketing', 'Segmentation'],
	configFields: [
		{ name: 'apiKey', label: 'Private API Key', type: 'password', required: true, placeholder: 'Enter your Klaviyo private API key' }
	],
	endpoints: [
		{
			name: 'Create/Update Profile',
			url: 'https://a.klaviyo.com/api/profile-import',
			method: 'POST',
			description: 'Add or update a profile in Klaviyo',
			cassieObjectID: -3,
			incrementField: 'syrenisID',
			resetIncrementValue: false,
			fields: [
				{ name: 'SyrenisID', filter: '' },
				{ name: 'Email1', filter: '' }
			],
			requestBody: '{	"data": {"type": "profile",		"attributes": {	"email": "[PLACEHOLDER_EMAIL1]","external_id": "<[PLACEHOLDER_SYRENISID]>",		"properties": {}	}}}',
			headers: [{ Name: 'Authorization', value: 'Klaviyo-API-Key [APIKEY]' }],
			successResponses: [{ code: 200, message: '' }, { code: 201, message: '' }]
		},
		{
			name: 'Subscribe',
			url: 'https://a.klaviyo.com/api/profile-subscription-bulk-create-jobs',
			method: 'POST',
			description: 'Subscribe a profile to lists',
			cassieObjectID: -5,
			incrementField: 'preferenceID',
			resetIncrementValue: false,
			fields: [
				{ name: 'Email1', filter: '' },
				{ name: 'ConsentDate', filter: '' },
				{ name: 'URN1', filter: '' }
			],
			requestBody: '{"data": {"type": "profile-subscription-bulk-create-job", "attributes": {"profiles": {"data": [{"type": "profile", "attributes": {"email": "[PLACEHOLDER_EMAIL1]", "id": "[PLACEHOLDER_URN1]", "subscriptions": {"email": {"marketing": {"consent": "SUBSCRIBED", "consented_at": "[PLACEHOLDER_CONSENTDATE]"}}}}}]}}}}',
			headers: [{ Name: 'Authorization', value: 'Klaviyo-API-Key [APIKEY]' }],
			successResponses: [{ code: 202, message: '' }]
		}
	],
	defaults: {
		endpointAddress: 'https://a.klaviyo.com/api',
		authenticationTypeId: AUTH_TYPES.API_KEY,
		frequencyInSeconds: 0,
		notes: 'Klaviyo email marketing and SMS automation platform integration.'
	}
}
